import React from 'react';



export default class SlideShow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slide: 0,
    }
  }

  render() {
    const hasMultipleImages = this.props.images.length > 1;

    return this.props.images.length > 0 ? <>
      <div className={`slideshow-container slide-fade ${this.props.carousel ? 'carousel-container' : ''}`}>
        {this.props.carousel ? this.renderCarouselSlides() : this.renderSlides()}
        {hasMultipleImages && <>
          <span className="prev" onClick={this.prevSlide}>&#10094;</span>
          <span className="next" onClick={this.nextSlide}>&#10095;</span>
        </>}
        {this.props.showDots && <div className='dots-wrapper'>
          {this.props.images.map((p,i) => 
            <span
              key={i}
              className={`dots ${i === this.state.slide ? 'active' : ''}`}
              onClick={() => this.setState({slide: i})}
            />
          )}
        </div>
        }
      </div>
    </> : null;
  }

  renderSlides() {
    return this.props.images.map((p,i) => 
      <div
        key={i}
        className='slide-container'
        style={{display: this.state.slide === i ? 'flex' : 'none'}}
      >
        <div
          className='image'
          style={{backgroundImage: `url(${p})`, 
                  backgroundPosition: 'center', 
                  backgroundSize: this.props.backgroundSize, 
                  height: this.props.height
                }}
        />
      </div>
    )
  }

  renderCarouselSlides() {
    return this.props.images.map((_,j) => {
      const i = (j + this.state.slide) % this.props.images.length;
      const p = this.props.images[i];
      return (
        <div
          key={i}
          className='carousel-slide-container'
          style={this.props.singleImage ? {display: this.state.slide === i ? 'flex' : 'none'} : null}
        >
          <div
            className={`image carousel-image ${this.props.singleImage ? 'centered' : ''}`}
            onClick={() => this.clickedSlide(i)}
            style={{
              backgroundPosition: 'center',
              backgroundImage: `url(${p})`,
              backgroundSize: 'contain',
              // TODO: maybe fetch the image size and adjust the width so image always fills the allotted height?
              width: `${this.props.imageWidth || 100}`,
              height: `${this.props.imageHeight || 100}`,
            }}
          />
        </div>
      )
    })
  }

  prevSlide = () => {
    let newSlide = this.state.slide - 1;
    if (newSlide < 0) {
      newSlide = this.props.wrapAround ? this.props.images.length - 1 : 0;
    }
    this.setState({ slide: newSlide });
  }

  nextSlide = () => {
    let newSlide = this.state.slide + 1;
    if (newSlide >= this.props.images.length) {
      newSlide = this.props.wrapAround ? 0 : this.props.images.length - 1;
    }
    this.setState({ slide: newSlide });
  }

  clickedSlide = (i) => {
    if (this.props.onImageClick) {
      this.props.onImageClick(this.props.images[i]);
    }
  }

}

SlideShow.defaultProps = {
  showDots: true,
}